// Lesson configuration constants
export const LESSON_CONFIG = {
  // Hours before lesson start when cancellation restrictions apply (no budget refund)
  CANCELLATION_RESTRICTION_HOURS: 24
};

// Helper function to check if lesson is within restriction hours
export const isLessonWithinRestrictionHours = (lesson, hoursBeforeRestriction = LESSON_CONFIG.CANCELLATION_RESTRICTION_HOURS) => {
  if (!lesson) {
    return false;
  }

  // Check if lesson is within the specified hours
  // Parse date and time from lesson object
  const lessonDateStr = lesson.date;
  const lessonTimeStr = lesson.time;
  
  // Extract start time (first part before " - ")
  const startTimeStr = lessonTimeStr.split(' - ')[0];
  
  // Create full datetime string and parse it
  const lessonDateTimeStr = `${lessonDateStr}T${startTimeStr}:00`;
  const lessonDateTime = new Date(lessonDateTimeStr);
  const now = new Date();
  
  const timeDifference = lessonDateTime.getTime() - now.getTime();
  const isWithinRestrictionHours = timeDifference <= (hoursBeforeRestriction * 60 * 60 * 1000);

  const isConfirmedStatus = lesson.status === 'CONFIRMED' || lesson.status === 'SCHEDULING';

  return isWithinRestrictionHours && isConfirmedStatus;
};

